import { render } from "./PricingDiscountSingleProduct.vue?vue&type=template&id=0dbc0430"
import script from "./PricingDiscountSingleProduct.vue?vue&type=script&lang=js"
export * from "./PricingDiscountSingleProduct.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/brekz-prestashop/brekz-prestashop/web/themes/brekz-2017/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__